module.exports = __webpack_public_path__ + "img/USA.d0fcfb15.png";